module.exports = __webpack_public_path__ + "media/answer_correct.683a2385.mp3";